var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell",class:[_vm.cell.prop, _vm.cell.propType,]},[_c('div',{staticClass:"app-table__cell-content"},[_c('el-button',{staticClass:"app-icon-btn small",attrs:{"title":"Редактировать"},on:{"click":function($event){return _vm.openCorpPopup()}}},[_c('icon',{attrs:{"name":"edit"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }